import { USER_FOUND } from 'redux-oidc';
import jwt from 'jwt-decode';
import useUserManager from '@ers/authorization/userManager';
import { getAccessToken } from '../App.selectors';

const { SentryLogger } = require('@ers/errors/');

class QueueManager {
    constructor() {
        this.Queue = [];
    }

    add(action) {
        this.Queue.push(action);
    }

    clear() {
        this.Queue = [];
    }

    get queue() {
        return this.Queue;
    }
}
const getExpirationDate = (token) => {
    const decoded = jwt(token);
    const d = new Date(0);
    d.setUTCSeconds(decoded.exp);
    return d;
};
class Reaction {
    constructor(compare, reaction) {
        this.compare = compare;
        this.reaction = reaction;
    }

    toObject() {
        return {
            compare: this.compare,
            reaction: this.reaction
        };
    }
}
class DepractedTokenAnalyzer {
    constructor() {
        this.reactions = [];
    }

    onApiCall(callback) {
        this.reactions.push(
            new Reaction(
                (action) => action.meta && action.meta.isApiCall,
                callback
            ).toObject()
        );
        return this;
    }

    onUserFound(callback) {
        this.reactions.push(
            new Reaction(
                (action) => action.type === USER_FOUND,
                callback
            ).toObject()
        );
        return this;
    }

    onDefault(callback) {
        this.reactions.push(new Reaction(() => true, callback).toObject());
        return this;
    }

    react(action) {
        const { reaction } = this.reactions.find((r) => r.compare(action));
        return reaction(action);
    }
}
export default () => {
    const queueManager = new QueueManager();
    const userManager = useUserManager();
    return (store) => (next) => (action) => new DepractedTokenAnalyzer()
        .onApiCall((a) => {
            const { getState } = store;
            const token = getAccessToken(getState());
            const d = getExpirationDate(token);
            if (d <= new Date()) {
                queueManager.add(a);
                SentryLogger.info(
                    `Access token expired. Queue length: ${queueManager.queue.length}.`
                );
                userManager.signinSilent();
                return null;
            }
            return next(a);
        })
        .onUserFound((a) => {
            if (queueManager.queue.length) {
                try {
                    const { length } = queueManager.queue;
                    queueManager.queue.forEach((queued) => {
                        next(queued);
                    });
                    queueManager.clear();
                    SentryLogger.info(
                        `Access token expired action queue cleared. The length was ${length}.`
                    );
                } catch (e) {
                    SentryLogger.error(
                        `Access token expired. Queue clearing failed.`
                    );
                }
            }
            return next(a);
        })
        .onDefault(next)
        .react(action);
};
